module.exports = __webpack_public_path__ + "img/plan4.4ef8d843.png";